import AppConstant from '../../../config/app.constants';
import BaseController from '../common/service_ticket_parts.base.controller'

class ServiceTicketsPartsEditController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, ServiceTicketPartsService, Modal, $translate, $q, $stateParams) {

        super(Auth, $state, User, ServiceTicketPartsService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$q = $q;
        this.$stateParams = $stateParams;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            loading: false
        }
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.Service.get(this.$stateParams.id)
        ])
            .then((data) => {
                this.serviceOrderPartsObj = data[0];
                this.defaultModel = this.serviceOrderPartsObj;
                this.rawId = this.serviceOrderPartsObj.id;
                this.model.label = this.serviceOrderPartsObj.label;
                this.model.serialNumber = this.serviceOrderPartsObj.serialNumber
                this.model.sortOrder = this.serviceOrderPartsObj.sortOrder;
                this.model.partCharge = this.serviceOrderPartsObj.partCharge;
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = err.data.message;
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    update() {
        this.model.isUpdating = true;
        this.Service.update(this.rawId, {
            partId: this.rawId,
            branchId: this.model.currentBranch,
            label: this.model.label,
            serialNumber: this.model.serialNumber,
            sortOrder: this.model.sortOrder,
            partCharge: this.model.partCharge
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = err.data.message;
                }
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }
}

export default ServiceTicketsPartsEditController;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/edit/service_ticket_parts.edit.controller.js